import Vue from "vue";
import App from "./App.vue";
import "lib-flexible";
import router from "./router";
import Vant from "vant";
import "vant/lib/index.css";
import "./assets/fonts/font.css"


Vue.use(Vant);
Vue.config.productionTip = false;
Vue.directive('lazyload', {
  inserted: function (el, binding) {
    const options = {
      rootMargin: '0px',
      threshold: 0.1
    };
    const observer = new IntersectionObserver(function(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = binding.value;
          observer.unobserve(img);
        }
      });
    }, options);
    observer.observe(el);
  }
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
